import React, { useEffect, useState } from "react";

import Preloader from "~/components/Preloader";
import InfoBlockPeople from "~/pages/IvideonDealerSummary2/Components/InfoBlock/InfoBlockPeople";
import FilterSummary from "~/widgets/Filters/FilterSummary";
import { useGetAnalyticaReport, useGetFaceAnalytics2 } from "~/entity/Ivideon";
import {
  AgeDetails,
  EmotionDetails,
  VisitTimeDetails,
} from "~/entity/Ivideon/model/schema";
import { faceVariables } from "~/pages/IvideonDealerSummary2/options";

import ChartsPeople from "./ChartsPeople";
import ItemChartPeople from "./ItemChartPeople";
import { getFaceData } from "./helper";

import styles from "~/pages/IvideonDealerSummary2/IvideonDealerSummary.less";

export interface FaceDataBarState {
  totalFaces: (number | null)[];
  uniqueFaces: (number | null)[];
  newFaces: (number | null)[];
  returningFaces: (number | null)[];
  male: (number | null)[];
  female: (number | null)[];
  ageDetails: AgeDetails;
  totalEmotionDetails: EmotionDetails;
  visitTimeDetails: VisitTimeDetails;
  overallAverageDwellTime: number;
}
export type LabelsType = string[] | string[][];

const PEOPLE_CHART_VARIANTS = [
  "uniqueFaces",
  "newFaces",
  "returningFaces",
  "gender",
  "visitTime",
];

const PeopleSummary = () => {
  const [variant, setVariant] = useState<string | null>(null);
  const [labels, setLabels] = useState<LabelsType>([]);
  const [dataBar, setDataBar] = useState<FaceDataBarState | null>(null);

  const { data, isLoading, setParamsFilter, dates } = useGetFaceAnalytics2();
  const { getAnalyticsReport } = useGetAnalyticaReport();

  useEffect(() => {
    if (data && dates) {
      const { startDate, endDate } = dates;

      getFaceData({
        startDate,
        endDate,
        data,
        setDataBar,
        setLabels,
      });
    }
  }, [dates, data, variant]);

  const handleInfoBlockClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = (e.target as HTMLElement).closest(
      "[data-variant]",
    ) as HTMLDivElement;
    if (!target) return;

    const nextVariant = target.dataset.variant ?? null;
    if (!nextVariant || !PEOPLE_CHART_VARIANTS.includes(nextVariant)) return;

    setVariant((prevVariant) =>
      prevVariant === nextVariant ? null : nextVariant,
    );
  };

  const handleVariant = (prop: string | null) => {
    setVariant(prop);
  };

  return (
    <div>
      <FilterSummary
        setParamsFilter={setParamsFilter}
        getAnalyticsReport={getAnalyticsReport}
        type="face"
      />
      {!isLoading && data && dataBar ? (
        <>
          <div
            className={styles.wrapper_content_total}
            onClick={handleInfoBlockClick}
          >
            <InfoBlockPeople data={data} variant={variant} />
          </div>
          <div className={styles.wrapperGraph}>
            {variant ? (
              <ItemChartPeople
                labels={labels}
                dataBar={
                  faceVariables({ dataBar, labels }).filter(
                    (item) => item.variant === variant,
                  )[0]
                }
                handleVariant={handleVariant}
                isLoading={isLoading}
              />
            ) : (
              <ChartsPeople
                dataBar={dataBar}
                labels={labels}
                handleVariant={handleVariant}
                isLoading={isLoading}
              />
            )}
          </div>
        </>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default PeopleSummary;
